import { WelcomeVideoOverlay } from './WelcomeVideoOverlay'

export default WelcomeVideoOverlay
